import * as React from 'react'
import { useRef, useState } from 'react'
import { Icon, Intent, EditableText, Button, Switch } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { splitDelimitedStringOrNull } from './inputOptionParser'

interface Props {
  onChange: (key, input) => void
  input: any
}

export default function ConfigureOptions({ onChange, input }: Props) {
  const [optionValue, setOptionValue] = useState('')
  const addOptionInput = useRef<HTMLInputElement>(null)

  const addDropDownOptions = (optionNames: string[]) => {
    let newOptions = [...(input.props.options || [])]
    optionNames.forEach(name => {
      if (!newOptions.find(option => option.key === name)) {
        newOptions = [...newOptions, { key: name, value: name }]
      }
    })
    onChange('options', newOptions)
  }

  const onAddDropdownOption = () => {
    addDropDownOptions([optionValue])
    setOptionValue('')
    addOptionInput.current?.focus()
  }

  const onRemoveOption = (idx: number) => {
    onChange(
      'options',
      (input.props.options || []).filter((_, i) => i !== idx)
    )
  }

  const onPreserveOrderChange = () => {
    onChange('preserveOrder', !input.props.preserveOrder)
  }

  const onInputChange = (idx: number, value: string) => {
    const newOptions = (input.props.options || []).map((opt, i) => (i === idx ? { key: value, value } : opt))
    onChange('options', newOptions)
  }

  const inputProps = input.props
  return (
    <div data-testid="builder-template-configure-input-container" style={{ background: 'white', padding: '10px' }}>
      <p>Add Options</p>
      <div>
        <Switch onChange={onPreserveOrderChange} label="Alphabetical order" checked={!inputProps.preserveOrder} />
      </div>
      <div className="bp3-control-group">
        <div className="bp3-input-group bp3-fill">
          <Icon icon={IconNames.ADD_TO_ARTIFACT} />
          <input
            ref={addOptionInput}
            type="text"
            className="bp3-input"
            placeholder="Type or paste to add options"
            value={optionValue}
            onChange={e => setOptionValue(e.target.value)}
            onKeyUp={e => {
              if (e.keyCode === 13 && optionValue) {
                onAddDropdownOption()
              }
            }}
            onPaste={e => {
              const pastedData = e.clipboardData.getData('text/plain')
              const optionNames = splitDelimitedStringOrNull(pastedData)
              if (optionNames) {
                addDropDownOptions(optionNames)
                e.preventDefault()
              }
            }}
            autoFocus
          />
        </div>
        <Button intent={Intent.PRIMARY} onClick={onAddDropdownOption}>
          Add
        </Button>
      </div>

      <div>
        {(inputProps.options || []).map((opt, i) => {
          return (
            <div key={i} /* eslint-disable-line */ style={{ display: 'flex', padding: '5px 0' }}>
              <EditableText minWidth={200} value={opt.key} onChange={v => onInputChange(i, v)} selectAllOnFocus />
              <Icon
                onClick={() => onRemoveOption(i)}
                style={{ marginLeft: 'auto', cursor: 'pointer' }}
                icon={IconNames.TRASH}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
                data-testid="delete-option"
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
